import React from 'react';
import { useGATrackingForSSR } from '../../utils/gaTracking';
import { useOnClickActionForSSR } from '../../utils/onClickActionForSSR';
import { removeFromRecentlyViewedVips } from '../../utils/storeToRecentlyViewedVips';

// Expired Listing is server side rendered we only need client for Breadcrumb and GA events to work
const ExpiredListingApp = ({ itemId }) => {
  useGATrackingForSSR();
  useOnClickActionForSSR();
  removeFromRecentlyViewedVips(itemId);

  return <></>;
};

export default ExpiredListingApp;
